import {Component, OnInit, signal} from '@angular/core';
import {Utils} from '../utils.class';
import {SubscriptionsService} from '../services/subscriptions.service';
import {Subscription} from '../classes/subscription';
import {CodaltComponent} from '../codalt.component';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {BreadcrumbComponent} from '../services/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-subscriptions',
    templateUrl: './subscriptions.component.html',
    styleUrls: ['./subscriptions.component.scss'],
    imports: [
        CurrencyPipe,
        DatePipe,
        RouterLink,
        BreadcrumbComponent
    ]
})
export class SubscriptionsComponent extends CodaltComponent implements OnInit {

    readonly companySubscriptions = signal<Subscription[]>(null);
    utils = Utils;

    constructor(
        private subscriptionsService: SubscriptionsService,
    ) {
        super();
    }

    ngOnInit() {
        this.crumbs = [
            {name: 'Financieel', route: this.Routenames.financials},
            {name: 'Abonnement', route: this.Routenames.subscriptions}
        ];
        this.subscriptions.add(
            this.subscriptionsService.getSubscriptions().subscribe((subscriptions) => {
                this.companySubscriptions.set(subscriptions);
            })
        );
    }
}
